// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import FrenchSouthernTerritories from '../_raw/flag/icon_flag_french_southern_territories.png';

export default () => <img src={FrenchSouthernTerritories} alt="FrenchSouthernTerritories" />;
